<div class="chat-history-container">
  <div class="chatlog-left-contianer">
    <div class="chat-messages">
      @for (log of logs; track log.id) {
      <div class="bot-message" *ngIf="log.type===TextType.AI">
        <div class=" w-75 d-flex flex-column align-items-end">
          <div class="message-container d-flex flex-column align-items-end gap-1 justify-content-end">
            <div class="d-flex align-items-center gap-2 mb-1">
              <p-tag [value]="propertyNumber" severity="info" [rounded]="true" *ngIf="propertyNumber"></p-tag>
              <p-tag [value]="log.context" severity="info" [rounded]="true"></p-tag>
              <h4 class="m-0">Petrie</h4>
            </div>
            <div class="message">{{ log.content }}</div>
            <div class="d-flex flex-column">
              <span>{{ formatMessageTime(log.time) }}</span>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="log.type===TextType.Human" class="user-message">
        <div class="w-75 d-flex flex-column align-items-start">
          <div class="message-container d-flex flex-column align-items-start gap-1 justify-content-end">
            <div class="d-flex align-items-center gap-2 mb-1">
              <h4 class="m-0">{{ contactInfo?.first_name || contactInfo?.last_name ? (contactInfo?.first_name || '') + (contactInfo?.last_name ? ' ' + contactInfo.last_name : '') : 'Guest' }}</h4>
              <p-tag [value]="senderNumber" severity="info" [rounded]="true" *ngIf="senderNumber"></p-tag>
              <p-tag [value]="log.context" severity="info" [rounded]="true"></p-tag>
            </div>
            <div class="d-flex flex-column align-items-center gap-4">
              <div class="message">{{ log.content }}</div>
            </div>
            <div class="d-flex flex-column">
              <span>{{ formatMessageTime(log.time) }}</span>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
  <div class="chatlog-right-contianer">
    <div class="chat-header">
      <h2>{{source+' LOG'}}</h2>
      <button pButton class="bg-transparent border-0" (click)="closeChat()">
        <i class="pi pi-times text-white bg-dark rounded-circle p-1"></i>
      </button>
    </div>
    <div class="row">
      <div class="col-lg-10 mt-3">
        <div class="form-group">
          <label for="name">Name</label>
          <input type="text" pInputText value="{{ (contactInfo?.first_name || '') + (contactInfo?.last_name ? ' ' + contactInfo.last_name : '') }}"  disabled/>
        </div>
      </div>
      <div class="col-lg-10">
        <div class="form-group">
          <label for="name">Email</label>
          <input type="mail" pInputText value="{{contactInfo?.email}}" disabled/>
        </div>
      </div>
      <div class="col-lg-10">
        <div class="form-group">
          <label for="name">Phone</label>
          <input type="text" pInputText value="{{contactInfo?.phone_number}}" disabled/>
        </div>
      </div>
      <div class="col-lg-10">
        <div class="form-group">
          <label for="name">Date</label>
          <input type="text" pInputText value="{{contactInfo?.chat_date | date:'MM/dd/YYYY' }}" disabled/>
        </div>
      </div>
      <!-- <div class="col-lg-12">
        <div class="form-group">
          <label for="name">Petrie Chat Log</label>
          <a href="javascript:avoid(0)" class="focused">{{hostName}}/{{propertyName}}/messaging/tour</a>
        </div>
      </div> -->
    </div>
  </div>
</div>